// extracted by mini-css-extract-plugin
export default {"QuoteLink":"QuoteLink_QuoteLink__YWY4N"};